import { useEffect, useState } from "react";
import { usePrefersReducedMotion } from "../lib/useReducedMotion";

// Event-driven preloader: dismisses on window 'load'. No dependency on rAF/timers/anim-end
// (some environments freeze offscreen animations), so it never blocks.
export function Preloader({ onDone }) {
  const reduced = usePrefersReducedMotion();
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const finish = () => {
      setGone(true);
      onDone?.();
    };
    if (reduced || document.readyState === "complete") {
      finish();
      return;
    }
    window.addEventListener("load", finish);
    return () => window.removeEventListener("load", finish);
  }, [reduced, onDone]);

  if (gone) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#08090B]"
      data-testid="preloader"
    >
      <svg width="96" height="112" viewBox="0 0 96 112" fill="none" className="mb-8">
        <path
          className="shield-draw"
          d="M48 4 L88 20 V54 C88 82 70 100 48 108 C26 100 8 82 8 54 V20 Z"
          stroke="#F0742A"
          strokeWidth="2.5"
          fill="none"
        />
        <path
          className="shield-fill"
          d="M30 72 C34 40 52 34 66 30 C50 40 46 56 44 78 C40 74 34 72 30 72 Z"
          fill="#F0742A"
        />
      </svg>
      <div className="heading preloader-count text-5xl text-white tabular-nums md:text-6xl" aria-hidden="true" />
      <div className="mt-3 font-inter text-xs tracking-[0.4em] text-hars-muted">HARSPRO</div>
    </div>
  );
}
